import { render, staticRenderFns } from "./SelectEmbajadorComponente.vue?vue&type=template&id=13bce795"
import script from "./SelectEmbajadorComponente.vue?vue&type=script&lang=js"
export * from "./SelectEmbajadorComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports